import { Controller } from "stimulus";
import insertElementBefore from "../../functions/insertElementBefore";

export default class extends Controller {
  static get targets() {
    return ["element", "cloneButtonContainer"];
  }

  connect() {
    this.cloneCount = 0;
    this.cloneableElement = this.elementTarget.outerHTML;
  }

  clone() {
    this.clonedElement = document.createElement("div");
    this.clonedElement.innerHTML = this.cloneableElement;

    this.clonedElement.querySelectorAll("div, input").forEach((container) => {
      if (container.id) {
        container.id = container.id.split("-clone-").at(0) + "-clone-" + this.cloneCount;
      }
    });

    this.cloneCount++;

    insertElementBefore(this.clonedElement, this.cloneButtonContainerTarget);
  }
}
